/*
Author: LiuBo
Date: 2018-09-05
Desc: 框架公用方法
*/
import conf from "@/config/index";
import cryptoJS from "@/assets/js/aes";
import cache from "@/assets/js/cache";
import util from "@/util";
import Vue from "vue";

export default {
    /* 获取/src/config/下的配置信息
  @inParam 无
  @return [Object] 配置对象，详见/src/config/config.js
  */
    getConfig() {
        return conf;
    },
    /* 迭代生成器，详见 ES6 API
  @inParam [Array] 需要迭代的数组
  @return [Object] 迭代器对象，可通过 [Object].next() 访问数组下一项，详见 ES6 API
  */
    * iterator(ary) {
        for (let i = 0; i < ary.length; i++) {
            yield ary[i];
        }
    },

    /* AES 加密
  @inParam [String] 要加密的值
  @return [String] 加密后的值
  */
    enc(str) {
        let isOpenGMEnc = sessionStorage.getItem("isOpenGMEnc", "");
        if(isOpenGMEnc === "1") {
            return SM4Crypto.encrypt_ECB(str, guid2().substr(0, randomNum(16, 32)));
        }else {
            let k = (conf.session_mode === "1") ? cache.getSessionKey() : conf.encKey;
            let srcs = cryptoJS.enc.Utf8.parse(str);
            let key = cryptoJS.enc.Utf8.parse(k);
            let iv = cryptoJS.enc.Utf8.parse(conf.encIV);
            let encrypted = cryptoJS.AES.encrypt(srcs, key, {
                iv: iv,
                mode: cryptoJS.mode.CBC
            });
            return encrypted.toString();
        }
        function guid2() {
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }

            return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        }

        function randomNum(minNum, maxNum) {
            switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * minNum + 1, 10);
                break;
            case 2:
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
                break;
            default:
                return 0;
                break;
            }
        }
    },
    /* 对字符串转义以防止跨站脚本攻击
  @inParam [String] 要转义的字符串
  @return [String] 转义后的字符串
  */
    xss(str) {
        if (!str) return "";
        str = String(str);
        str = str.replace("<", "&lt;");
        str = str.replace(">", "&gt;");
        str = str.replace("'", "&apos;");
        str = str.replace("\"", "&quot;");
        return str;
    },
    // -----------以下为表单验证方法，用于页面上validator 类型的校验-----------------
    /* 校验表单手机号信息
   @inParam [Object] rule 校验规则信息
   @inParam [String] value 获取到的校验项值
   @inParam [Object] callback 校验后回调函数
   */
    validateMobile(rule, value, callback) {
        if (value === "") {
            callback();
        }
        if (/^(1)(\d{10})$/.test(value)) {
            callback();
        } else {
            callback(new Error("手机号码输入不正确"));
        }
    },
    /* 校验邮政编码
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validatePostCode(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^\d{6}$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("邮政编码输入不正确"));
        }
    },
    /* 校验邮箱地址
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateEmail(rule, value, callback) {
        if (util.isEmpty(value)) {
            callback();
        }
        const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("邮箱输入不正确"));
        }
    },
    /* 校验电话号码或传真号码
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateFaxNum(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^\d{3,5}[-]\d{4,8}$/;
        if (value !== "" && !reg.test(value)) {
            callback(new Error("号码输入不正确,如028-99999"));
        } else {
            callback();
        }
    },
    /* 校验是否为英文字母
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateChar(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^[a-zA-Z0-9\s]+$/;
        if (!(reg.test(value) && value.trim() !== "")) {
            callback(new Error("只能输入英文字母及数字"));
        } else {
            callback();
        }
    },
    /* 校验是否为大于0的正整数
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateInt(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^[1-9]*[1-9][0-9]*$/;
        if (!reg.test(value)) {
            callback(new Error("只能输入大于0的正整数"));
        } else {
            callback();
        }
    },
    /* 校验是否为标识符(只允许字母、数字和下划线)
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateIdentifier(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^\w+$/;
        if (!reg.test(value)) {
            callback(new Error("只能输入字母、数字或下划线"));
        } else {
            callback();
        }
    },
    /* 获字符串过滤
  @param [String] val 过滤值
  @return [String] 过滤后的字符串
  */
    filterCode(val) {
        return val.replace(/[^\u4e00-\u9fa5\w()]/g, "");
    },
    /*获取页面URL参数
        /*入参  str[String] 字符串格式的URL路径，可选，如不提供默认取当前页面URL
        /*返回  [object] url参数键值对，key为参数名，value 为参数值
        /********************************************************************/
    getUrlParams(str) {
        str = decodeURI(str || location.href);
        let idx = str.indexOf("?"),
            params = {},
            ary = [];
        if (idx != -1) {
            str = str.substring(idx + 1, str.length);
            ary = str.split("&");
            for (let i = 0; i < ary.length; i++) {
                let _idx = ary[i].indexOf("=");
                params[ary[i].substring(0, _idx)] = decodeURIComponent(ary[i].substring(_idx + 1, ary[i].length));
            }
        }
        return params;
    }
};
var SM4Crypto = function () {
    function f(r, n) {
        return r[n] << 24 | r[n + 1] << 16 | r[n + 2] << 8 | r[n + 3];
    }

    function s(r, n, t) {
        n[t] = r >>> 24, n[t + 1] = r >>> 16, n[t + 2] = r >>> 8, n[t + 3] = r;
    }

    function c(r, n) {
        return (4294967295 & r) << n | r >>> 32 - n;
    }

    var n = [[214, 144, 233, 254, 204, 225, 61, 183, 22, 182, 20, 194, 40, 251, 44, 5], [43, 103, 154, 118, 42, 190, 4, 195, 170, 68, 19, 38, 73, 134, 6, 153], [156, 66, 80, 244, 145, 239, 152, 122, 51, 84, 11, 67, 237, 207, 172, 98], [228, 179, 28, 169, 201, 8, 232, 149, 128, 223, 148, 250, 117, 143, 63, 166], [71, 7, 167, 252, 243, 115, 23, 186, 131, 89, 60, 25, 230, 133, 79, 168], [104, 107, 129, 178, 113, 100, 218, 139, 248, 235, 15, 75, 112, 86, 157, 53], [30, 36, 14, 94, 99, 88, 209, 162, 37, 34, 124, 59, 1, 33, 120, 135], [212, 0, 70, 87, 159, 211, 39, 82, 76, 54, 2, 231, 160, 196, 200, 158], [234, 191, 138, 210, 64, 199, 56, 181, 163, 247, 242, 206, 249, 97, 21, 161], [224, 174, 93, 164, 155, 52, 26, 85, 173, 147, 50, 48, 245, 140, 177, 227], [29, 246, 226, 46, 130, 102, 202, 96, 192, 41, 35, 171, 13, 83, 78, 111], [213, 219, 55, 69, 222, 253, 142, 47, 3, 255, 106, 114, 109, 108, 91, 81], [141, 27, 175, 146, 187, 221, 188, 127, 17, 217, 92, 65, 31, 16, 90, 216], [10, 193, 49, 136, 165, 205, 123, 189, 45, 116, 208, 18, 184, 229, 180, 176], [137, 105, 151, 74, 12, 150, 119, 126, 101, 185, 241, 9, 197, 110, 198, 132], [24, 240, 125, 236, 58, 220, 77, 32, 121, 238, 95, 62, 215, 203, 57, 72]],
        h = [2746333894, 1453994832, 1736282519, 2993693404],
        v = [462357, 472066609, 943670861, 1415275113, 1886879365, 2358483617, 2830087869, 3301692121, 3773296373, 4228057617, 404694573, 876298825, 1347903077, 1819507329, 2291111581, 2762715833, 3234320085, 3705924337, 4177462797, 337322537, 808926789, 1280531041, 1752135293, 2223739545, 2695343797, 3166948049, 3638552301, 4110090761, 269950501, 741554753, 1213159005, 1684763257];

    function p(r) {
        return n[r >>> 4][r % 16];
    }

    function o(r, n, t, e, u) {
        return r ^ (t = n ^ t ^ e ^ u, e = new Uint8Array(4), u = new Array(4), s(t, e, 0), u[0] = p(e[0]), u[1] = p(e[1]), u[2] = p(e[2]), u[3] = p(e[3]), (u = f(u, 0)) ^ c(u, 2) ^ c(u, 10) ^ c(u, 18) ^ c(u, 24));
    }

    function a(r, n) {
        var t, e, u, o = new Array(4), a = new Array(36), i = 0;
        for (o[0] = f(n, 0), o[1] = f(n, 4), o[2] = f(n, 8), o[3] = f(n, 12), a[0] = o[0] ^ h[0], a[1] = o[1] ^ h[1], a[2] = o[2] ^ h[2], a[3] = o[3] ^ h[3]; i < 32; i++) a[i + 4] = a[i] ^ (t = a[i + 1] ^ a[i + 2] ^ a[i + 3] ^ v[i], u = e = void 0, e = new Uint8Array(4), u = new Array(4), s(t, e, 0), u[0] = p(e[0]), u[1] = p(e[1]), u[2] = p(e[2]), u[3] = p(e[3]), (u = f(u, 0)) ^ c(u, 13) ^ c(u, 23)), r[i] = a[i + 4];
    }

    function g(r, n, t) {
        var e = 0, u = new Array(36);
        for (u[0] = f(n, 0), u[1] = f(n, 4), u[2] = f(n, 8), u[3] = f(n, 12); e < 32;) u[e + 4] = o(u[e], u[e + 1], u[e + 2], u[e + 3], r[e]), e++;
        s(u[35], t, 0), s(u[34], t, 4), s(u[33], t, 8), s(u[32], t, 12);
    }

    function e(r, n) {
        r.mode = 1, a(r.sk, n);
    }

    function u(r, n) {
        for (var t = 0, e = n.length, u = []; 0 < e;) {
            var o = n.slice(t, t + 16), a = new Uint8Array(16);
            g(r.sk, o, a);
            for (var i = 0; i < 16; i++) u[t + i] = a[i];
            t += 16, e -= 16;
        }
        return u;
    }

    function i(r) {
        for (var n = [], t = 0; t < r.length; t++) {
            var e = r.charCodeAt(t);
            65536 <= e && e <= 1114111 ? (n.push(e >> 18 & 7 | 240), n.push(e >> 12 & 63 | 128), n.push(e >> 6 & 63 | 128), n.push(63 & e | 128)) : 2048 <= e && e <= 65535 ? (n.push(e >> 12 & 15 | 224), n.push(e >> 6 & 63 | 128), n.push(63 & e | 128)) : 128 <= e && e <= 2047 ? (n.push(e >> 6 & 31 | 192), n.push(63 & e | 128)) : n.push(255 & e);
        }
        return n;
    }

    var d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    function l(r) {
        for (var n, t, e, u, o, a, i = "", f = 0; f < r.length;) e = (a = r[f++]) >> 2, u = (3 & a) << 4 | (n = r[f++]) >> 4, o = (15 & n) << 2 | (t = r[f++]) >> 6, a = 63 & t, isNaN(n) ? o = a = 64 : isNaN(t) && (a = 64), i = i + d.charAt(e) + d.charAt(u) + d.charAt(o) + d.charAt(a);
        return i;
    }

    function A(r) {
        if (!r) return "We@53&es&esT*7%s";
        var n = (r = r.replace(/[^\x00-\xff]/g, "00")).length;
        if (16 === n) return r;
        if (16 < n) return r.substring(0, 16);
        for (var t = 0; t < 16 - n; t++) r = "0" + r;
        return r;
    }

    return {
        encrypt_ECB: function (r, n) {
            var t = {mode: 0, sk: [], mode: 1};
            e(t, i(A(n)));
            r = l(u(t, i(r)));
            return "GMJM" + (n.length < 10 ? "0" : "") + n.length + n + r;
        }, encrypt_ECB2: function (r) {
            var n = {mode: 0, sk: [], mode: 1};
            return e(n, i(A(ui.global.user.userID + "_" + r))), l(u(n, i(r)));
        }, decrypt_ECB: function (r) {
            var n = parseInt(r.substr(0, 2)), t = r.substr(2, n), r = r.substr(2 + n), n = {mode: 0, sk: [], mode: 0};
            return function (r, n) {
                r.mode = 0, a(r.sk, n);
                for (var t, e, u, o = 0; o < 16; o++) t = r.sk, u = void 0, u = t[e = o], t[e] = t[31 - e], t[31 - e] = u;
            }(n, i(A(t))), function (r) {
                if ("string" == typeof r) return r;
                for (var n = "", t = r, e = 0; e < t.length; e++) {
                    var u = t[e].toString(2), o = u.match(/^1+?(?=0)/);
                    if (o && 8 === u.length) {
                        for (var a = o[0].length, i = t[e].toString(2).slice(7 - a), f = 1; f < a; f++) i += t[f + e].toString(2).slice(2);
                        n += String.fromCharCode(parseInt(i, 2)), e += a - 1;
                    } else "0" != t[e] && (n += String.fromCharCode(t[e]));
                }
                return n;
            }(u(n, function (r) {
                var n, t, e, u, o, a, i = [], f = 0;
                for (r = r.replace(/[^A-Za-z0-9\+\/\=]/g, ""); f < r.length;) e = d.indexOf(r.charAt(f++)), n = (15 & (u = d.indexOf(r.charAt(f++)))) << 4 | (o = d.indexOf(r.charAt(f++))) >> 2, t = (3 & o) << 6 | (a = d.indexOf(r.charAt(f++))), i.push(e << 2 | u >> 4), 64 !== o && i.push(n), 64 !== a && i.push(t);
                return i;
            }(r))).trim();
        }
    };
}();
